import React from 'react'

export default function System() {
    return (
        <div className="div-header">
            <h1 className="text-center">Paramétrage Système</h1>
        </div>
    )
}
